// invetory main index
import Inventory from "../../pages/Inventory/index"
import InventoryList from "../../pages/Invoices/invoices-list"
import InvoiceDetail from "../../pages/Invoices/invoices-detail"
import Unit from "../../pages/Inventory/unit"
import Type from "../../pages/Inventory/type"
import GroupIndex from "../../pages/Inventory/group/index"
import Brand from "../../pages/Inventory/brand"
import Product from "../../pages/Inventory/product/index"
import InventoryFil from "../../pages/Invoices"
import StockSummary from "../../pages/Procurement/stockSummary"
import VoucherEntrySearch from "../../pages/Finance/voucherEntry"
import EditVoucherEntry from "../../pages/Finance/voucherEntry/edit"
import VoucherEntryView from "../../pages/Finance/voucherEntry/view"
import StockJournalReport from "../../pages/Inventory/stockJournal"
import InventoryVoucherEntrySearch from "../../pages/Inventory/inventoryVoucherEntries"
import EditInventoryVoucherEntry from "../../pages/Inventory/inventoryVoucherEntries/edit"
import InventoryVoucherEntryView from "../../pages/Inventory/inventoryVoucherEntries/view"
import POReportSearch from "../../pages/Inventory/poReport"
import RequestedList from "../../pages/CentralStore/requestList"
import ReqView from "../../pages/CentralStore/requestList/view"
import SMRSearch from "../../pages/Inventory/smr"
import EditSMR from "../../pages/Inventory/smr/edit"
import DeliveryNoteVoucherSearch from "../../pages/Inventory/deliveryNote"
import ViewSmr from "../../pages/Inventory/smr/view"
import GRNVoucherSearch from "../../pages/Inventory/grn"
import MaterialInSearch from "../../pages/Inventory/materialIn"
import MaterialOutSearch from "../../pages/Inventory/materialOut"
import RejectionOutSearch from "../../pages/Inventory/rejectionOut"
import RejectionInSearch from "../../pages/Inventory/rejectionIn"
import ProjectMaster from "../../pages/ProjectManagement/projectMaster"

export const inventoryRoutes = [
  { path: "/inventory", component: <Inventory /> },
  { path: "/inventory-unit", component: <Unit /> },
  { path: "/inventory-type", component: <Type /> },
  { path: "/inventory-group", component: <GroupIndex /> },
  { path: "/inventory-brand", component: <Brand /> },
  { path: "/inventory-product", component: <Product /> },
  { path: "/inventory-list", component: <InventoryList /> },
  { path: "/invoices-detail", component: <InvoiceDetail /> },
  { path: "/invoices-detail/:id", component: <InvoiceDetail /> },
  { path: "/inventory-fil", component: <InventoryFil /> },
  { path: "/inventory-stocksummary", component: <StockSummary /> },
  { path: "/inventory-voucher", component: <InventoryVoucherEntrySearch /> },
  { path: "/inventory-voucher/add", component: <EditInventoryVoucherEntry /> },
  { path: "/inventory-voucher/edit/:editId", component: <EditInventoryVoucherEntry /> },
  { path: "/inventory-voucher/view/:id", component: <InventoryVoucherEntryView /> },
  { path: "/inventory-book", component: <StockJournalReport /> },
  { path: "/inventory-procurement-report", component: <POReportSearch /> },
  { path: "/inventory-inward-pmr", component: <RequestedList /> },
  { path: `/inventory-inward-pmr/view/:id`, component: <ReqView /> },
  { path: `/inventory-outward-smr`, component: <SMRSearch /> },
  { path: `/inventory-outward-smr/add`, component: <EditSMR /> },
  { path: `/inventory-outward-smr/edit/:id`, component: <EditSMR /> },
  { path: `/inventory-outward-smr/view/:id`, component: <ViewSmr /> },
  { path: "/inventory-delivery-note", component: <DeliveryNoteVoucherSearch /> },
  { path: "/inventory-receipt-note", component: <GRNVoucherSearch /> },
  { path: "/inventory-material-in", component: <MaterialInSearch /> },
  { path: "/inventory-material-out", component: <MaterialOutSearch /> },
  { path: "/inventory-rejection-in", component: <RejectionInSearch /> },
  { path: "/inventory-rejection-out", component: <RejectionOutSearch /> },
  {path: "/inventory-project-master", component: <ProjectMaster />},
]
